import React from "react";
import { Outlet } from "react-router-dom";

const WareHouse: React.FC = () => {
  return <Outlet />;
};

export default WareHouse;